module.exports = __webpack_public_path__ + "img/4.90795d2f.jpeg";